<template>
  <div class="zbsp-box">
    <div class="zbsp-table">
      <div class="zbsp-table-header">
        <span class="zbsp-col zbsp-col-num">{{$t('all.shangpinxuhao')}}</span>
        <span class="zbsp-col zbsp-col-img">{{$t('all.shangpinshoutu')}}</span>
        <span class="zbsp-col zbsp-col-name">{{$t('all.shangpinmingcheng')}}</span>
        <span class="zbsp-col zbsp-col-stock">UNImall {{$t('all.shangchengkucun')}}</span>
        <span class="zbsp-col zbsp-col-live-stock">{{$t('all.zhibokucun')}}</span>
        <span class="zbsp-col zbsp-col-price">UNImall {{$t('all.shangchengjiage')}}</span>
        <span class="zbsp-col zbsp-col-live-price">{{$t('all.zhibojiage')}}</span>
        <span class="zbsp-col zbsp-col-action">{{$t('all.caozuo')}}</span>
      </div>
      <div class="zbsp-table-body">
        <div class="zbsp-table-row" v-for="(item, index) in list" :key="index">
          <span class="zbsp-col zbsp-col-num">{{index + 1}}</span>
          <span class="zbsp-col zbsp-col-img">
            <img class="zbsp-product-img" :src="item.imgUrl" alt="" />
          </span>
          <span class="zbsp-col zbsp-col-name">{{item.name}}</span>
          <span class="zbsp-col zbsp-col-stock">{{item.mallStock}}</span>
          <span class="zbsp-col zbsp-col-live-stock">
            <div class="zbsp-counter">
			  <img class="zbsp-counter-btn" @click="decreaseLiveStock(item)" src="../../../assets/image/shuliang_jian@2x.png" alt="" />
              <span class="zbsp-counter-value">{{item.liveStock}}</span>
			  <img class="zbsp-counter-btn" @click="increaseLiveStock(item)" src="../../../assets/image/shuliang_jia@2x.png" alt="" />
            </div>
          </span>
          <span class="zbsp-col zbsp-col-price">{{item.mallPrice}}</span>
          <span class="zbsp-col zbsp-col-live-price">
            <div class="zbsp-counter">
			  <img class="zbsp-counter-btn" @click="decreaseLivePrice(item)" src="../../../assets/image/shuliang_jian@2x.png" alt="" />
              <span class="zbsp-counter-value">{{item.livePrice}}</span>
			  <img class="zbsp-counter-btn" @click="increaseLivePrice(item)" src="../../../assets/image/shuliang_jia@2x.png" alt="" />
            </div>
          </span>
          <span class="zbsp-col zbsp-col-action">
            <span class="zbsp-remove" @click="handleRemove(index)">{{$t('all.yichu')}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const mockList = [];
      for (let i = 0; i < 20; i++) {
        mockList.push({
          imgUrl: 'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17815051910743367.png',
          name: '速修熬夜眼\n7天眼周焕亮',
          mallStock: 23456,
          liveStock: 341,
          mallPrice: 100,
          livePrice: 68
        });
      }
      this.list = mockList;
    },
    decreaseLiveStock(item) {
      if (item.liveStock > 0) item.liveStock--;
    },
    increaseLiveStock(item) {
      if (item.liveStock < item.mallStock) item.liveStock++;
    },
    decreaseLivePrice(item) {
      if (item.livePrice > 0) item.livePrice--;
    },
    increaseLivePrice(item) {
      item.livePrice++;
    },
    handleRemove(index) {
      this.list.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="scss">
@import "./zhiboshangpin.css";
</style>



// WEBPACK FOOTER //
// zhiboshangpin.vue?76e0a29c